import Vuetable from 'vuetable-2/src/components/Vuetable';
import email from 'vuelidate/src/validators/email';
import Avatar from '@/components/Avatar/Avatar';
import ChoiceGroup from '@/components/ChoiceGroup/ChoiceGroup';
import Avatars from '@/components/Avatars';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/Button/Button';
import Input from '@/components/Input/Input';
import Highlight from '@/components/Highlight';
import Label from '@/components/Label/Label';
import LabelList from '@/components/LabelList';
import Pagination from '@/components/Pagination';
import sort from '@/utils/Sort';
import arraysData from '@/utils/ArraysData';
import Context from '@/models/Context';
import Group from '@/models/core/Group';
import Topic from '@/models/strategy/Topic';
import { mapActions, mapGetters } from 'vuex';
import ToastWrapper from '@/components/ToastWrapper/ToastWrapper';
import MultiSelectSearch from '../../MultiSelectSearch/MultiSelectSearch';

export default {
  name: 'ThemesTable',
  components: {
    Vuetable,
    Avatar,
    Avatars,
    Button,
    Input,
    Modal,
    Label,
    LabelList,
    ToastWrapper,
    MultiSelectSearch,
    Pagination,
    ChoiceGroup,
    Highlight
  },
  props: ['themes'],
  data() {
    return {
      reset: false,
      sortOrder: 'asc',
      sortColumn: 'name',
      selectedThemes: [],
      searchFor: [],
      selected: [],
      selectionOriginal: [],
      selectionTheme: '',
      single: {
        item: null,
        candidateText: '',
        original: null
      },
      modal: {
        delete: {
          single: false,
          multiple: false
        },
        update: false,
        create: false,
        users: false
      },
      newTheme: {
        name: '',
        autoSubscribe: false,
        parent_id: null,
        color: null,
        posts: 0,
        groups_collection: []
      },
      colors: [
        { background: '#003e73' },
        { background: '#005cac' },
        { background: '#0070d2' },
        { background: '#7c3233' },
        { background: '#ba4a4c' },
        { background: '#e35a5c' },
        { background: '#8c6433' },
        { background: '#d1964d' },
        { background: '#ffb75d' },
        { background: '#235c3b' },
        { background: '#3ea66a' },
        { background: '#4bca81' },
        { background: '#1e4948' },
        { background: '#33998f' },
        { background: '#4dc0b5' },
        { background: '#3d345e' },
        { background: '#6b5ba6' },
        { background: '#8f79de' },
        { background: '#2e355e' },
        { background: '#4a5596' },
        { background: '#6574cd' },
        { background: '#703247' },
        { background: '#ca5a7f' },
        { background: '#f66d9b' }
      ]
    };
  },
  watch: {
    openModal: {
      immediate: true,
      handler(val, oldVal) {
        if (val) {
          this.modal.create = val;
          this.$emit('resetOpenModal');
        }
      }
    }
  },
  computed: {
    shouldHighlight() {
      const highlight = [];

      this.searchFor.map(search => {
        if (search.type === 'fuzzy') {
          highlight.push(search.id);
        }
        if (search.type === 'topic') {
          highlight.push(search.name.replace('Topic: ', ''));
        }
      });

      return highlight;
    },
    filteredThemes() {
      return this.themes.filter(current => {
        let shouldReturn = !this.searchFor.length;

        this.searchFor.map(search => {
          if (search.type === 'fuzzy' && !shouldReturn) {
            shouldReturn = current.name.toLowerCase().indexOf(search.id) > -1;
          }

          if (search.type === 'topic' && !shouldReturn) {
            shouldReturn = current.id === search.id;

            if (!shouldReturn) {
              current.children.map(child => {
                if (child.id === search.id) {
                  shouldReturn = true;
                }
              });
            }
          }
        });

        if (shouldReturn) {
          return current;
        }
      });
    },
    sortedThemes() {
      return sort(this.filteredThemes, this.sortColumn, this.sortOrder);
    },
    iconDirection() {
      return this.sortOrder === 'asc' ? 'sort-up' : 'sort-down';
    },
    allSelected() {
      return (
        Topic.all().length === this.selectedThemes.length &&
        this.sortedThemes.length
      );
    },
    deleteCandidateText() {
      return this.selectedThemes.length === 1
        ? this.selectedThemes[0].name
        : `${this.selectedThemes.length} themes`;
    },
    isNewValid() {
      return this.newTheme.name.trim().length > 0;
    },
    isDeleting: function() {
      return this._isDeleting();
    },
    isUpdating: function() {
      return this._isUpdating();
    },
    searchGroups() {
      const groups = Group.query()
        .orderBy('name')
        .get()
        .map(group => {
          return { id: group.id, name: `Group: ${group.name}`, type: 'group' };
        });

      const options = [
        {
          groupName: 'Groups',
          groupValues: groups
        }
      ];

      return options;
    },
    searchOptions() {
      const topics = Topic.query()
        .orderBy('name')
        .get()
        .map(topic => {
          return { id: topic.id, name: `Topic: ${topic.name}`, type: 'topic' };
        });

      const options = [
        {
          groupName: 'Topics',
          groupValues: topics
        }
      ];

      return options;
    }
  },
  methods: {
    ...mapActions({
      _newToast: 'toasts/_addToast',
      _topicRemove: 'entities/topics/remove',
      _topicCreate: 'entities/topics/create',
      _topicUpdate: 'entities/topics/update',
      _topicMembers: 'entities/topics/members'
    }),
    ...mapGetters({
      _isDeleting: 'entities/topics/isDeleting',
      _isUpdating: 'entities/topics/isUpdating'
    }),
    resetPage() {
      this.selectedThemes = [];
      this.reset = true;
    },
    onMultiAction(value) {
      this.selected.push(value);
    },
    namesOnly(original) {
      return original.map(item => {
        return item.name;
      });
    },
    sortOn(column) {
      if (column === this.sortColumn) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
    },
    select(value) {
      if (this.selectedThemes.includes(value)) {
        this.selectedThemes = this.selectedThemes.filter(current => {
          return current !== value;
        });
      } else {
        this.selectedThemes.push(value);
      }
    },
    selectAll() {
      if (this.allSelected) {
        this.selectedThemes = [];
      } else {
        this.sortedThemes.map(theme => {
          if (!this.selectedThemes.includes(theme)) {
            this.selectedThemes.push(theme);
          }
          theme.children.map(topic => {
            if (!this.selectedThemes.includes(topic)) {
              this.selectedThemes.push(topic);
            }
          });
        });
      }
    },
    isSelected(value) {
      return this.selectedThemes.includes(value) ? 'checked' : '';
    },
    closeCreateModal() {
      this.modal.create = false;
      this.newTheme = {
        name: '',
        autoSubscribe: false,
        parent_id: null,
        color: null,
        posts: 0,
        groups_collection: []
      };
    },
    deleteSingle(value) {
      this.single.candidateText = value.name;
      this.single.item = value;
      this.modal.delete.single = true;
    },
    updateSingle(value) {
      this.single.candidateText = value.name;
      this.single.item = Object.assign({}, value);
      this.single.item.groups_collection = value.groups.map(group => {
        return { id: group.id, name: group.name };
      });
      this.single.item.children = value.children;
      this.single.original = value;
      this.modal.update = true;
    },
    updateSingleAction() {
      this.single.original.name = this.single.item.name;
      this.single.original.posts = this.single.item.posts;
      this.single.original.autoSubscribe = this.single.item.autoSubscribe;
      this.single.original.color = this.single.item.color;
      this.single.original.parent_id = this.single.item.parent_id;
      this.single.original.groups_collection = this.single.item.groups_collection.map(
        group => {
          return group.id;
        }
      );

      this._topicUpdate(this.single.original).then(() => {
        this._newToast({
          text: 'Theme has been successfully updated',
          variant: 'good',
          duration: 2000
        });
        this.single.item = null;
        this.single.original = null;
        this.modal.update = false;
      });
    },
    deleteSingleAction() {
      this._topicRemove([this.single.item]).then(() => {
        this.single.candidateText = '';
        this.single.item = null;
        this.modal.delete.single = false;

        this._newToast({
          text: 'Theme has been successfully removed',
          variant: 'good',
          duration: 2000
        });
      });
    },
    deleteSelectionAction() {
      this._topicRemove(this.selectedThemes).then(() => {
        this.modal.delete.multiple = false;

        if (this.allSelected) {
          this.updateCurrentPage(1);
        } else {
          this.selectedThemes = [];
        }

        this._newToast({
          text: 'Theme has been successfully removed',
          variant: 'good',
          duration: 2000
        });
      });
    },
    createAction() {
      this._topicCreate(this.newTheme).then(() => {
        this.closeCreateModal();

        this._newToast({
          text: 'Theme has been created',
          variant: 'good',
          duration: 2000
        });
      });
    },
    usersAction(value) {
      this.selectionTheme = value.id;
      this.selected = value.members.map(member => {
        return member.id;
      });

      this.selectionOriginal = value.members.map(member => {
        return member.id;
      });

      this.modal.users = true;
    },
    updateThemeUsers() {
      const data = {
        theme: this.selectionTheme,
        values: arraysData(this.selected, this.selectionOriginal)
      };

      this._topicMembers(data);

      this.modal.users = false;
    },
    updateCurrentPage(currentPage) {
      this.selectedThemes = [];
      this.currentPage = currentPage;
      this.reset = false;
    }
  }
};
